export const CHILD_MIN_WIDTH = 110